import { FC } from "react";

import { SUBSCRIPTIONS } from "Bands/constants";
import { SubscriptionMessage } from "Bands/containers";
import { useBandSubscriptionContext, useCompanyContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import { SubscriptionTypeWithTrial } from "Bands/types";
import { getDaysLeft, useBandRoute } from "Bands/utils";
import { capitalize } from "lodash";
import { copy } from "shared/assets";
import { Edit, Wallet } from "shared/assets/icons";
import {
  Button,
  ButtonContainer,
  Card,
  FancyButtonLink,
  FancyLink,
} from "shared/components";
import { Spacer } from "shared/layout";
import { BoldText, MutedDarkText, MutedText } from "shared/styles";
import { IStatus } from "shared/types";
import { buildUrl } from "shared/utils";

const {
  bandSettings: { subscription, bandSettingsIds },
} = copy;

export const Subscription: FC = () => {
  const { currentSubscription, isActiveSubscription } =
    useBandSubscriptionContext();
  const { userCompanies } = useCompanyContext();
  const { pushRoute } = useBandRoute();

  const activeSubscription =
    currentSubscription?.plan &&
    currentSubscription?.plan !== SubscriptionTypeWithTrial.trial
      ? SUBSCRIPTIONS[currentSubscription?.plan]
      : null;

  const currentCompany = currentSubscription?.company
    ? userCompanies.find((company) =>
        currentSubscription?.company?.id?.includes(company.id)
      )
    : null;

  const renderContent = () => {
    if (
      currentSubscription?.plan === SubscriptionTypeWithTrial.trial &&
      currentSubscription?.stop
    ) {
      const daysLeft = getDaysLeft(currentSubscription.stop);

      return (
        <Spacer size="s">
          <Spacer size="xxs">
            <BoldText>{capitalize(currentSubscription.plan)}</BoldText>
            <MutedText>
              {daysLeft} {subscription.daysLeft}
            </MutedText>
          </Spacer>
          <Button
            onClick={() => pushRoute(BAND_PATHS.SUBSCRIPTION_OVERVIEW)}
            size="s"
          >
            {subscription.cta}
          </Button>
        </Spacer>
      );
    }

    if (isActiveSubscription && activeSubscription) {
      return (
        <Spacer size="s" data-testid="band_settings_subscription">
          <span>
            <MutedDarkText>{subscription.title}: </MutedDarkText>
            {currentCompany ? (
              <FancyLink
                to={buildUrl(BAND_PATHS.COMPANY_DASHBOARD, {
                  companyId: currentCompany.id,
                })}
              >
                {activeSubscription.title}
              </FancyLink>
            ) : (
              <>{activeSubscription.title}</>
            )}
          </span>

          {currentCompany && (
            <span>
              <MutedDarkText>{subscription.company}: </MutedDarkText>
              <FancyLink
                to={buildUrl(BAND_PATHS.COMPANY_DASHBOARD, {
                  companyId: currentCompany.id,
                })}
              >
                {currentCompany.name}
              </FancyLink>
            </span>
          )}

          <ButtonContainer>
            <FancyButtonLink
              onClick={() => pushRoute(BAND_PATHS.EDIT_SUBSCRIPTION_PLAN)}
              status={IStatus.default}
              icon={Edit}
            >
              {copy.subscription.summary.edit}
            </FancyButtonLink>
          </ButtonContainer>
        </Spacer>
      );
    }

    return <SubscriptionMessage isCenter={false} />;
  };

  return (
    <Card
      id={bandSettingsIds.subscription}
      icon={Wallet}
      title={subscription.title}
    >
      <Spacer size="s">{renderContent()}</Spacer>
    </Card>
  );
};
